/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import Grid from '../../../../../../../SharedModules/Table/tableGrid';
import CustomCommentComponent from '../../../CustomCommentComponent';
import CustomDateComponent from '../../../CustomDateComponent';

const DisplayFamilyTableComponent = ({ tableData, tableHead }) => {
  const childRef = useRef(null);
  const [gridApi, setGridApi] = useState(null);
  const [columnApi, setColumnApi] = useState(null);
  const [tableCount, setTableCount] = useState(0);

  const onGridReady = useCallback((params) => {
    setGridApi(params.api);
    setColumnApi(params.columnApi);
    setTableCount(params.api.getDisplayedRowCount());
  }, []);

  useEffect(() => {
    gridApi && gridApi.setFilterModel(null);
    setTableCount(gridApi && gridApi.getDisplayedRowCount());
  }, [gridApi, tableData]);
  return (
    <div className="table-container fourRecords mt-3">
      <Grid
        rowData={tableData}
        noRowPadding={true}
        onGridReady={onGridReady}
        defaultCol={{ editable: false }}
        columnDefs={tableHead}
        isModalTable={true}
        cellClickedListener={(e) => {}}
        frameworkComponents={{
          commentComponent: CustomCommentComponent,
          dateComponent: CustomDateComponent,
        }}
        onFilterChanged={() => setTableCount(gridApi.getDisplayedRowCount())}
      />
      <p className="total-results" tabIndex="0">
        Total Results: <b>{tableCount?.toLocaleString('en-US')}</b>
      </p>
    </div>
  );
};

export default DisplayFamilyTableComponent;
